// ...existing code...
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import "./assets/css/common.css";
import React, { useEffect, useState } from "react";
import Spinner from "./components/Spinner";
import SubscriptionPage from "./pages/Subscription";

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1200); // Simulate loading
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Spinner />;
  }

  return (
    <ConfigProvider
      locale={enUS}
      theme={{
        token: {
          fontFamily: "Inter, sans-serif",
          colorText: "var(--white-color)",
          colorPrimary: "var(--primary)",
          colorLink: "#00e1ffff",
          colorLinkHover: "var(--primary)",
          fontSize: 14,
          colorError: "#ef4c5c",
          colorSuccess: "#23d100",
        },
        components: {
          Typography: {
            titleMarginTop: 0, 
          },
          Form: {
            labelColor: "var(--white-color)",
            colorPrimary: "var(--primary)",
            labelFontSize: 12,
            itemMarginBottom: 28,
            colorError: "#ef4c5c",
            colorSuccess: "#23d100",
          },
          Input: {
            colorBgContainer: "var(--card-bg)", // background color
            colorText: "var(--white-color)", // text color
            colorBorder: "var(--card-border)", // border color
            colorTextPlaceholder: "#8b949e", // placeholder color
            activeBorderColor: "#58a6ff", // border when focused
            hoverBorderColor: "#58a6ff", // border on hover
            borderRadius: 8, // rounded corners
            controlHeight: 40,
            addonBg: '#979797ff',
          },
          Button: {
            colorPrimary: "var(--primary)",
            colorPrimaryHover: "var(--white-color)",
            colorPrimaryActive: "var(--white-color)",
            borderRadius: 8,
            paddingInline: 12,
            paddingBlock: 8,
            primaryShadow: "none",
            controlHeight: 40,
            defaultBorderColor: "#e4e1e6",
            defaultColor: "var(--primary)",
            defaultBg: "var(--white-color)",
            defaultHoverBorderColor: "#edf3ff",
            defaultHoverColor: "#78767A",
            defaultHoverBg: "#edf3ff",
            defaultActiveColor: "var(--primary)",
            defaultActiveBorderColor: "#e4e1e6",
            textTextColor: "#2e364c",
            
          },
          Card: {
            colorBgContainer: "var(--card-bg)",
            colorBorderSecondary: "var(--card-border)",
            //padding: 0,
          },
          Alert: {
            colorText: "#ef4c5c",
            colorIconHover: "var(--primary)",
          },
           Layout: {
            siderBg:"var(--card-bg)",
            headerBg:"var(--card-bg)",
          },
          Dropdown: {
            colorBgElevated: "--primary", // dropdown background color
            colorText: "#fff", 
            controlItemBgHover: "var(--link-color)", 
            colorPrimaryBorder: "#fff", 
          },
          Table:{
            headerBg: "var(--card-bg)", 
            bodySortBg:  "var(--card-border)",
            borderColor: "var(--card-border)",
            headerColor:'#fff',
            headerSortActiveBg:  "var(--card-border)",
            colorBgContainer: "var(--card-bg)", 
            cellPaddingBlock: 5,
            cellPaddingInline: 8,
            cellFontSize: 14,
            rowHoverBg:  "var(--card-border)",
            rowSelectedBg:  "var(--card-border)",
            headerFilterHoverBg:  "var(--card-border)",
            headerSortHoverBg:  "var(--card-border)",
            colorIcon:"#38bdf8", 
          },
           Pagination: {
            itemActiveBg:"var(--link-color)", 
            itemBg:"var(--card-bg)", 
            itemLinkBg:  "var(--card-border)", 
          },
           Select: {
            optionActiveBg: "var(--card-border)", 
            optionSelectedBg: "var(--card-border)", 
            selectorBg: "var(--card-bg)", 
            colorBgElevated: "var(--bg-dark)",
            colorBorder:"var(--card-border)", 
            colorIconHover: '#fff',
          },  
        },
      }}
    >
      <BrowserRouter>
<AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          
          {/* Updated route with both stripeId and userId */}
          <Route
            path="/subscriptions/:stripeId/:userId"
            element={
              <ProtectedRoute>
                <SubscriptionPage />
              </ProtectedRoute>
            }
          />
          
          {/* Redirect root to dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          
          {/* 404 - Not Found */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
      </BrowserRouter>
    </ConfigProvider>
  );
};

export default App;
